import React, { useEffect, useRef, useState } from "react";
import BreadcrumbSection from "../../../components/BreadcrumbSection";
import {
  Button,
  Col,
  Container,
  Image,
  ListGroup,
  Nav,
  Row,
  Card,
} from "react-bootstrap";
import IMAGES from "../../../constants/images";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { BsHeart } from "react-icons/bs";
import ReviewsComponent from "../../../components/ReviewsComponent";
import TextInput from "../../../components/TextInput";
import CommonModal from "../../../components/CommonModal";
import ClientAccordionComponent from "components/ClientAccordionComponent";
import ClientPricingCards from "components/ClientPricingCards";
import { useAuth } from "context/UserContext";

// Sample integration data
const integrations = [
  { name: "Slack", img: IMAGES.LogoIcon_IMG1 },
  { name: "Zoom", img: IMAGES.LogoIcon_IMG2 },
  { name: "AWS", img: IMAGES.LogoIcon_IMG3 },
  { name: "Google Drive", img: IMAGES.LogoIcon_IMG4 },
  { name: "Dropbox", img: IMAGES.LogoIcon_IMG5 },
  { name: "HubSpot", img: IMAGES.LogoIcon_IMG6 },
  { name: "Salesforce", img: IMAGES.LogoIcon_IMG7 },
  { name: "Tableau", img: IMAGES.LogoIcon_IMG8 },
  { name: "GitHub", img: IMAGES.LogoIcon_IMG9 },
  { name: "Jira", img: IMAGES.LogoIcon_IMG10 },
  { name: "Mailchimp", img: IMAGES.LogoIcon_IMG11 },
  { name: "Zendesk", img: IMAGES.LogoIcon_IMG12 },
  { name: "Shopify", img: IMAGES.LogoIcon_IMG13 },
  { name: "Zapier", img: IMAGES.LogoIcon_IMG14 },
];

const RatingStars = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span
        key={i}
        style={{
          color: i <= rating ? "#FFC107" : "#ccc",
          fontSize: "1.2rem",
          marginRight: "4px",
        }}
      >
        ★
      </span>
    );
  }
  return <span>{stars}</span>;
};

const images = [
  { src: IMAGES.Media_Img6, cols: 6, rows: 3 }, // Large main image
  { src: IMAGES.Media_Img7, cols: 6, rows: 1 }, // Top right
  { src: IMAGES.Media_Img8, cols: 6, rows: 1 }, // Below top-right
  { src: IMAGES.Media_Img9, cols: 6, rows: 2 }, // Bottom left
  { src: IMAGES.Media_Img10, cols: 6, rows: 2 }, // Bottom right
];

const SolutionProductDetails = () => {
  const navigate = useNavigate();
  const {  user } = useAuth();
  const [activeTab, setActiveTab] = useState("Product Overview");
  const [show, setShow] = useState(false);

  // Section references for smooth scrolling
  const sectionRefs = {
    "Product Overview": useRef(null),
    Pricing: useRef(null),
    Media: useRef(null),
    "Company Info": useRef(null),
    Reviews: useRef(null),
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sectionRefs[tab]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const navRef = useRef(null);

  useEffect(() => {
    if (navRef.current) {
      navRef.current.style.scrollbarWidth = "none"; // Firefox
      navRef.current.style.overflowX = "auto";
      navRef.current.style.whiteSpace = "nowrap";
    }
  }, []);

  return (
    <React.Fragment>
      {/* BreadCrumb Section */}
      <BreadcrumbSection
        breadcrumbs={[
          {
            title: "Solutions",
            link: "/solutions",
            title1: "/client-side-protection-solutions",
            link1: "Client-Side Protection",
          },
          { title: "Cloudflare Application Security & Performance" }, // No link because it's active
        ]}
      />
      <section className="product_section">
        <Image src={IMAGES.Product_Img1} alt="" className="img-fluid" />
        <Container>
          <Row>
            <Col lg={12}>
              <div className="product__header">
                <div
                  className="product__header__iconBox"
                  style={{
                    backgroundColor: "#FFDDE2",
                  }}
                >
                  <Image src={IMAGES.C_Logo1} alt="" className="img-fluid" />
                </div>
                <div className="product_contentBox">
                  <div className="product_content">
                    <div className="product_content_flex">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <h2>Cloudflare Application Security & Performance</h2>
                        <Button className="follow" variant="info" size="sm">
                          Follow
                        </Button>
                      </div>
                      <div className="product_rating">
                        <RatingStars rating={4.5} /> (2306) 4.7 out of 5{" "}
                        {/* <span className="divider1">|</span>{" "}
                        <span className="discussion">22 Discussion</span> */}
                      </div>
                    </div>
                    <Button variant="outline-danger">
                      <Icon
                        icon="mingcute:contacts-3-fill"
                        fontSize={25}
                        className="me-2"
                      />
                      Contact Cloudflare
                    </Button>
                  </div>
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 flex-wrap">
                    <Link className="d-flex align-items-center text-secondary fw-normal font14 text-decoration-none">
                      <BsHeart className="text-danger me-2" size={20} />
                      Save to My List
                    </Link>
                    <Button
                      variant="outline-danger"
                      className="ms-0 ms-md-auto px-3 border-radius-100"
                    >
                      Entry Level Price:{" "}
                      <span className="text-primary">$ Free</span>
                    </Button>
                    <Button variant="info" className="border-radius-100 px-4">
                      Try For Free
                    </Button>
                  </div>
                </div>
              </div>

              <div className="nav_Flex">
                <div className="scroll-container" ref={navRef}>
                  <Nav
                    variant="tabs"
                    className="flex-nowrap"
                    defaultActiveKey="Product Overview"
                  >
                    {[
                      "Product Overview",
                      "Pricing",
                      "Media",
                      "Company Info",
                      "Reviews",
                    ].map((tab) => (
                      <Nav.Item key={tab}>
                        <Nav.Link
                          eventKey={tab}
                          active={activeTab === tab}
                          onClick={() => handleTabClick(tab)}
                          style={{
                            backgroundColor:
                              activeTab === tab ? "#E91515" : "transparent",
                            color: activeTab === tab ? "white" : "black",
                          }}
                        >
                          {tab}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </div>
                <div className="d-flex gap-4 helpFull">
                  <Link
                    to={"/community"}
                    className="text-decoration-none blueColor d-flex align-items-center "
                  >
                    <Icon
                      icon="hugeicons:user-question-02"
                      fontSize={20}
                      className="me-2"
                    />{" "}
                    Community
                  </Link>
                  <Link
                    to={"/disputes"}
                    className="text-decoration-none redColor d-flex align-items-center"
                  >
                    <Icon
                      icon="bx:comment-error"
                      fontSize={22}
                      className="me-2"
                    />{" "}
                    Disputes
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="product_overview bg-light"
        ref={sectionRefs["Product Overview"]}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <h2 className="h2">
                Cloudflare Application Security and Performance Overview
              </h2>
              <p>
                Cloudflare is the cloud for the “everywhere world”. At
                Cloudflare, we have our eyes set on an ambitious goal -- to help
                build a better Internet. Today, everything needs to be connected
                to everything everywhere, all the time. This hyperconnectivity
                creates new challenges related to security, performance,
                resilience and privacy. As the world’s first connectivity cloud,
                Cloudflare helps connect and protect millions of customers
                globally. Everyone from individuals to the world’s largest
                enterprises use our unified platform of networking, security,
                and developer services to succeed in the eve...
                <Link>See More</Link>
              </p>
              <h3 className="mb-2">Product Description</h3>
              <p>
                Cloudflare Application Security and Performance solutions
                provide performance, reliability, and security for all of your
                web applications and APIs, wherever they are hosted and wherever
                your users are.
              </p>

              <h3 className="mb-0">Other Details</h3>
              <Row className="mb-4">
                <Col lg={6}>
                  <ListGroup className="customListGroup">
                    <ListGroup.Item>
                      <Icon icon="gg:website" fontSize={24} />
                      <span>
                        <strong>Product Website</strong> (
                        <Link>Project Manager, CEO</Link>)
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Icon icon="iconoir:language" fontSize={24} />
                      <span>
                        <strong>Languages</strong> (German, English, French,
                        Italian, Japanese, Korean, Dutch, Polish, Portuguese,
                        Russian, Spanish, Swedish, Turkish, Chinese
                        (Traditional))
                      </span>
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
                <Col lg={6}>
                  <ListGroup className="customListGroup">
                    <ListGroup.Item>
                      <Icon icon="tabler:users" fontSize={24} />
                      <span>
                        <strong>Users</strong> (Web Developer, Software
                        Engineer)
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Icon icon="clarity:building-line" fontSize={24} />
                      <span>
                        <strong>Industries</strong> (Marketing & Advertising, IT
                        and Services)
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Icon icon="ph:line-segments" fontSize={24} />
                      <span>
                        <strong>Market Segment</strong> (63% Small-Business, 29%
                        Mid-Market)
                      </span>
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
              </Row>

              <h3>Features</h3>
              <ClientAccordionComponent />
              <h3 className="mt-4">Integrations</h3>
              <div className="integradionFlex">
                {integrations.map((integration, index) => (
                  <div key={index} className="shadowCard">
                    <Card className="text-center">
                      <Card.Body>
                        <Image
                          src={integration.img}
                          alt={integration.name}
                          style={{ width: "70px", height: "70px" }}
                        />
                      </Card.Body>
                    </Card>
                    <Card.Footer className="text-center">
                      {integration.name}
                    </Card.Footer>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="product_overview">
        <Image src={IMAGES.Lines_IMG} className="lines_pos" alt="" />
        <Container>
          <Row>
            <Col lg={12}>
              <h2 ref={sectionRefs["Pricing"]}>
                Cloudflare Application Security and Performance Pricing
              </h2>
              <p>
                Cloudflare Application Security and Performance has 3 pricing
                editions. A free trial of Cloudflare Application Security and
                Performance is also available. Look at different pricing
                editions below and see what edition and features meet your
                budget and needs.
              </p>
              <ClientPricingCards />
              <h2 className="h2 mb-5" ref={sectionRefs["Media"]}>
                Cloudflare Application Security and Performance Media
              </h2>
              <Row className="g-3">
                <Col md={6}>
                  <Card className="collage-card large">
                    <Card.Img variant="top" src={images[0].src} />
                  </Card>
                </Col>
                <Col md={6}>
                  <Row className="g-3">
                    <Col xs={12}>
                      <Card className="collage-card small">
                        <Card.Img variant="top" src={images[1].src} />
                      </Card>
                    </Col>
                    <Col xs={12}>
                      <Card className="collage-card small">
                        <Card.Img variant="top" src={images[2].src} />
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="g-3 mt-1">
                <Col md={6}>
                  <Card className="collage-card medium">
                    <Card.Img variant="top" src={images[3].src} />
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="collage-card videoBox medium">
                    <Card.Img variant="top" src={images[4].src} />
                    <div className="playButton">
                      <Card.Img variant="top" src={IMAGES.Play_Circle} />
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="product_overview" ref={sectionRefs["Company Info"]}>
        <Image src={IMAGES.Lines_IMG} className="lines_pos" alt="" />
        <Container>
          <Row>
            <Col lg={12}>
              <h2>
                Cloudflare Application Security and Performance Company Info
              </h2>
              <p>
                Cloudflare, Inc. (NYSE: NET) is the leading connectivity cloud
                company. It empowers organizations to make their employees,
                applications and networks faster and more secure everywhere,
                while reducing complexity and cost. Cloudflare’s connectivity
                cloud delivers the most full-featured, unified platform of
                cloud-native products and developer tools, so any organization
                can gain the control they need to work, develop, and accelerate
                their business. Powered by one of the world’s largest and most
                interconnected networks, Cloudflare blocks billions of threats
                online for its customers every day. It is trusted by millions of
                organizations – from the largest brands to entrepreneurs and
                small businesses to nonprofits, humanitarian groups, and
                governments across the globe.
              </p>
            </Col>
          </Row>
          <h3 className="mb-0">Seller Details</h3>
          <Row className="mb-4">
            <Col lg={6}>
              <ListGroup className="customListGroup">
                <ListGroup.Item>
                  <Icon icon="mdi:hand-coin-outline" fontSize={24} />
                  <span>
                    <strong>Seller</strong> (<Link>monday.com</Link>)
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Icon icon="gg:website" fontSize={22} />
                  <span>
                    <strong>Company Website</strong> (<Link>monday.com</Link>)
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Icon icon="stash:data-date" fontSize={24} />
                  <span>
                    <strong>Year Founded</strong> (2012)
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Icon icon="mynaui:location" fontSize={24} />
                  <span>
                    <strong>HQ Location</strong> (Tel Aviv)
                  </span>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col lg={6}>
              <ListGroup className="customListGroup">
                <ListGroup.Item>
                  <Icon icon="prime:twitter" fontSize={24} />
                  <span>
                    <strong>Twitter</strong> (<Link>Project Manager, CEO</Link>,
                    41,809 Twitter followers)
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Icon icon="mingcute:linkedin-line" fontSize={24} />
                  <span>
                    <strong>LinkedIn Page</strong> (
                    <Link>www.linkedin.com</Link>, 2,802 employees on LinkedIn®)
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Icon icon="solar:user-linear" fontSize={24} />
                  <span>
                    <strong>Ownership</strong> (NASDAQ: MNDY)
                  </span>
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="product_section pro_pad bg-light"
        ref={sectionRefs["Reviews"]}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <div className="product__header">
                <div className="product_contentBox">
                  <div className="product_content">
                    <div className="product_content_flex">
                      <div className="mb-2">
                        <h2>
                          Cloudflare Application Security and Performance
                          Reviews
                        </h2>
                      </div>
                      <div className="product_rating">
                        <RatingStars rating={4.5} /> (2306) 4.7 out of 5
                      </div>
                    </div>
                    {(!user || user.role === "user") && <Button
                      variant="danger"
                      onClick={() => {
                        navigate("/write-a-review");

                        localStorage.removeItem("step");
                        localStorage.removeItem("checkedProducts");
                        localStorage.removeItem("verificationId");
                      }}
                    >
                      Write A Review
                    </Button>}
                  </div>
                </div>
              </div>

              <ReviewsComponent onReviewClick={() => setShow(true)} />
            </Col>
          </Row>
        </Container>
      </section>

      <CommonModal
        image
        paraStyle={{ maxWidth: "600px", marginTop: "10px" }}
        title="Comment on Review"
        para="Share your thoughts or ask questions about this review to join the conversation and provide additional insights."
        body={
          <>
            <TextInput
              labelText={"Comment"}
              type="email"
              textarea="textarea"
              rows={6}
              placeholder={"Write Your Comment..."}
            />
            <Button
              variant="info"
              onClick={() => setShow(false)}
              className="w-100 border-radius-100 mt-3"
            >
              Continue
            </Button>
          </>
        }
        show={show}
        onClose={() => setShow(false)}
      />
    </React.Fragment>
  );
};
export default SolutionProductDetails;
